export default function () {
  const initialState = {
    isLoading: true,
    data: {},
  }

  return initialState
}
